<template>
  <div class="pto_request">
    <v-form ref="pto_form" v-model="valid" lazy-validation>
      <v-row pt-50>
        <v-col
          class="prompt first-row"
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
          >Legal Name</v-col
        >
        <v-col
          class="first-row"
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom9cols: $vuetify.breakpoint.smAndUp,
          }"
        >
           {{this.pto.firstname}}  {{this.pto.lastname}} 
           <span style="display:none;"> {{this.pto_data.firstname}} </span>

          <v-tooltip right v-model="show_tooltip_legal_name" max-width="300px">
            <template v-slot:activator="{}">
              <v-btn
                v-click-outside="hide_legal_name"
                @click="showTooltip('legal_name')"
                icon
                aria-label="More information"
              >
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </template>
            <span>{{ this.tooltips.legal_name }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-subheader class="pl-0 prompt">I work on weekends</v-subheader>
        </v-col>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            custom3cols: $vuetify.breakpoint.smAndUp,
          }"
        >
          <v-switch
            v-model="work_weekends"
            aria-label="I work on weekends"
          ></v-switch>
        </v-col>
        <v-col
          :class="{
            custom1cols: $vuetify.breakpoint.xs,
            hidden: $vuetify.breakpoint.smAndUp,
          }"
        >
        </v-col>
      </v-row>

      <div class="form-group" v-for="(input, k) in inputs" :key="k">
        <v-row>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Start Date</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom9cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-menu
              v-model="input.start_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="input.start"
                  aria-label="Select Start Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  single-line
                  dense
                  required
                  @click="populate_default(k, 'start')"
                  :rules="startDateRules"
                  class="messages"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="input.start"
                :allowed-dates="allowedDates"
                :min="date_picker_min"
                :max="date_picker_max"
                no-title
                color="#4f2c1d"
                class="dt-picker"
                @input="
                  input.start_menu = false;
                  !!input.end
                    ? (input.end = input.end)
                    : (input.end = input.start);
                "
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">End Date</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom9cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-menu
              v-model="input.end_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="input.end"
                  aria-label="Select End Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  single-line
                  dense
                  required
                  @click="populate_default(k, 'end')"
                  :rules="endDateRules"
                  class="messages"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="input.end"
                :allowed-dates="allowedDates"
                :min="date_picker_min"
                :max="date_picker_max"
                no-title
                color="#4f2c1d"
                class="dt-picker"
                @input="input.end_menu = false"
                required
              ></v-date-picker>
            </v-menu>

          </v-col>
        </v-row>

        <v-row>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Type of PTO</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom9cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-select
              v-model="input.type"
              :rules="typeRules"
              :items="pto_types"
              item-value="id"
              item-text="name"
              aria-label="PTO Type"
              class="messages"
              outlined
              single-line
              dense
              required
              :menu-props="{maxHeight: '350'}"
            />
            <div v-if="input.type == 'sick'" >
              <p class="inst">
                <ul>
                 <li>Please note a doctor's note is required to return to work if you take 5+ consecutive sick days for employees' own personal use.</li>
                 <li>For clarity on the allotted number of days for covid please visit the: <a href="https://www.adelphi.edu/policies/covid-19-leave/" target="_blank" class="bold-link">https://www.adelphi.edu/policies/covid-19-leave/</a></li>
                </ul>
              </p>
             </div>
             <div v-else-if="input.type == 'jury_duty'" >
              <p class="inst">For details, please visit <a href="https://www.adelphi.edu/hr/benefits/jury-duty/" target="_blank" class="bold-link">Time off for Jury Duty</a></p>
             </div>
             <div v-else-if="input.type == 'bereavement'" >
              <p class="inst">For clarity on the allotted number of days for bereavement please visit the <a href="https://www.adelphi.edu/policies/bereavement/" target="_blank" class="bold-link">Bereavement Leave Policy</a> page.</p>
             </div>
             <div v-else-if="input.type == 'prenatal'" >
              <p class="inst">Prenatal Care leave can be used by employees for their own health care services received during their pregnancy or related to such pregnancy, including physical examinations, medical procedures, monitoring and testing, and discussions with a health care provider related to the pregnancy. It can also be used for fertility treatment or care appointments and end-of-pregnancy care appointments. Employees must use this benefit in hourly increments. </p>
             </div>

             <div v-else-if="input.type == 'covid'" >
              <p class="inst">
               <ul>
                 <li>For details, please visit "Vaccine Requirements and FAQs for Faculty, Staff and Administration" section on <a href="https://www.adelphi.edu/coronavirus/health-wellness-safety/vaccination-information/" target="_blank" class="bold-link">Vaccine Information</a> page.</li>
                 <li>Per New York state law, all Adelphi employees are entitled to four (4) hours of paid time off per COVID-19 vaccine injection. You can read more about it on <a href="https://dol.ny.gov/system/files/documents/2021/10/cd6-paid-leave-for-covid19-vaccinations-10-12-21_0.pdf" target="_blank" class="bold-link">the NYS website</a>.</li>
                 <li>You should notify your manager of scheduled appointments in advance and note the time off as “½ CV” (Covid Vaccine) on your time cards/sheets.</li>
                </ul>
              </p>
             </div>
            <div v-else-if="input.type == 'covid_sick'" >
              <p class="inst">
                <ul>
                 <li>For clarity on the allotted number of days for covid please visit the: <a href="https://www.adelphi.edu/policies/covid-19-leave/" target="_blank" class="bold-link">https://www.adelphi.edu/policies/covid-19-leave/</a></li>
                 <li>Please contact Health Services at <a class="bold-link" href="mailto:healthservicescenter@adelphi.edu">healthservicescenter@adelphi.edu</a> for further guidance.</li>
                </ul>
              </p>
             </div>             
             <div v-else >
              <p class="inst">Non-Union employees are entitled to one floating holiday per year for President's Day. This holiday can be used on the date or later.</p>
            </div>

          </v-col>
        </v-row>


        <v-row v-if="input.type == 'prenatal'">
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Prenatal Care</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom6cols: $vuetify.breakpoint.smAndUp,
            }"
          >
              From: <vue-timepicker v-model="input.prenatal_start" format="hh:mm a" minute-interval="30" hide-clear-button auto-scroll fixed-dropdown-button
              ></vue-timepicker>&nbsp;&nbsp;&nbsp;
              To: <vue-timepicker v-model="input.prenatal_end" format="hh:mm a" minute-interval="30" hide-clear-button auto-scroll fixed-dropdown-button
              ></vue-timepicker>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              hidden: $vuetify.breakpoint.smAndUp,
            }"
          >
          </v-col>
        </v-row>        
        <v-row v-else >
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-subheader class="pl-0 prompt">Full or Partial Days</v-subheader>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom4cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-radio-group v-model="input.full_partial" mandatory>
              <v-radio
                label="Full Day"
                value="FULL"
                class="black--text"
              ></v-radio>
              <v-radio
                label="Half Day (Morning)"
                value="AM"
                class="black--text"
              ></v-radio>
              <v-radio
                label="Half Day (Afternoon)"
                value="PM"
                class="black--text"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              hidden: $vuetify.breakpoint.smAndUp,
            }"
          >
          </v-col>
        </v-row>

        <v-row v-show="k || (!k && inputs.length > 1)">
          <v-col
            class="pt-0 pb-0"
            :class="{
              hidden: $vuetify.breakpoint.xs,
              custom3cols: $vuetify.breakpoint.smAndUp,
            }"
          ></v-col>
          <v-col
            class="pt-0 pb-0"
            :class="{
              custom1cols: $vuetify.breakpoint.xs,
              custom9cols: $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-btn
              class="ma-2 pl-0"
              color="#fff"
              depressed
              @click="remove(k)"
              v-show="k || (!k && inputs.length > 1)"
            >
              <v-icon left color="#4f2c1d"> mdi-minus-circle </v-icon>
              Remove
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pl-0">
            <v-divider
              width="100%"
              v-show="k || (!k && inputs.length > 1)"
            ></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              class="ma-2"
              color="#fff"
              depressed
              @click="add(k)"
              v-show="k == inputs.length - 1"
            >
              <v-icon left color="#4f2c1d"> mdi-plus-circle </v-icon>
              Add more dates
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-row class="submit-row">
        <v-col cols="12">
          <v-btn
            class="ma-2"
            color="#FFB500"
            :disabled="!valid"
            depressed
            @click="submitPto"
          >
            Submit Changes
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div class="text-center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ dialog_title }}
          </v-card-title>
          <v-card-text>{{ dialog_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog(dialog_type)">
              {{ dialog_ok }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2" persistent max-width="600">
        <v-card>
          <v-toolbar
                class="text-xs-center justify-center title white--text darken-2 font-weight-bold"
                color="blue"
                dark
              ><v-icon class="alert_spacing" >mdi-alert</v-icon>{{ dialog2_title }} </v-toolbar>
          <!-- v-card-title class="headline"> 
          </v-card-title -->
          <v-card-text style="padding-top: 20px;" class="black--text" >{{ this.dialog2_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog2(dialog2_type)">
              {{ dialog2_ok }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </div>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import ClickOutside from "vue-click-outside";
import axios from "axios";
import pto_func from "@/pto_functions";
import moment from 'moment';

var current_day = pto_func.get_today_date()
  .toLocaleString("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "UTC"
  })
  .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");

export default {

  components: {
    VueTimepicker,
  },

  directives: {
    ClickOutside,
  },

  props: ["ptoInfo"],

  data: () => ({
    dialog: false,
    dialog_title: "Alert!",
    dialog_ok: "OK",
    dialog_text: "",
    dialog_type: "",
    dialog2: false,
    dialog2_title: "Alert",
    dialog2_ok: "OK",
    dialog2_text: "",
    dialog2_type: "",
    valid: true,
    k: 0,
    work_weekends: false,
    show_tooltip_legal_name: false,
    today: current_day,

    tooltips: {
      legal_name:
        "This is the legal name listed on your official W2 forms and may also be needed to ensure the accuracy of claims with benefits. If you change your legal name, please contact Human Resources.",
    },

    //pto_types: pto_func.getPtoCats("object"),
    pto_types: [],

    au_holidays: [],
    saas_holidays: null,
    date_picker_min: pto_func.get_date_picker_min(),
    date_picker_max: "",

    inputs: [
      {
        start_menu: "",
        end_menu: "",
        start: "",
        end: "",
        type: "",
        full_partial: "",
        prenatal_start: "12:00 am",
        prenatal_end: "12:00 am"
      },
    ],

    typeRules: [(v) => !!v || "Type of PTO is required"],
    startDateRules: [(v) => !!v || "Start Date is required"],
    endDateRules: [(v) => !!v || "End Date is required"],

    saas_data: [null],
    pto_data: [null],
    pto_data_next_yr: [null],
    pto_data_prev_yr: [null],
    site_status: pto_func.get_site_status(),

    cur_fiscal_year: pto_func.get_fiscal_year("cur_long"),
    next_fiscal_year: pto_func.get_fiscal_year("next_long"),
    prev_fiscal_year: pto_func.get_fiscal_year("prev_long"),

    pto: pto_func.pto_set_format(),

  }),

  methods: {

    showTooltip(name) {
      eval("this.show_tooltip_" + name + " = true");
    },

    // During transition_rough period in early sept, request feature is shutdown. 
    // To do that: default start/end drop down to Aug 1 so the Aug calendar would be triggered. 
    // Since date_picker_max was hardcoded to Aug 31, the program won't show the Sept calendar at all.
    populate_default(k, type) { 
      if (this.site_status == "transition_rough") {
          var default_end_year = pto_func.get_default("default_end_year");
          if (type == "start" && !this.inputs[k].start) // start date dropdown
            this.inputs[k].start = default_end_year + "-08-01";
          if (type == "end" && !this.inputs[k].end) // end date dropdown
            this.inputs[k].end = default_end_year + "-08-01";
      }
      return;      
    },

    hide_legal_name() {
      this.show_tooltip_legal_name = false;
    },

    closeDialog() {
      this.dialog = false;

      if (this.dialog_type == "success") {
        window.location.reload();
      } else if (this.dialog_type == "balance") {
        this.$router.push({
          path: "/pto/balance",
        });
      }
    },

    closeDialog2() {
      this.dialog2 = false;
    },    

    allowedDates(val) {
      // disable holidays and, if applicable, weekends
      var disallowed = false;
      for (var i = 0; i < this.au_holidays.length; i++) {
        if (this.au_holidays[i] == val) {
          disallowed = true;
          break;
        }
      }

      if (disallowed == false) {
        if (this.work_weekends === false) {
          // emp do not work on weekends, disable weekends
          var d = new Date(val + "T09:00:00.000Z");
          if (d.getDay() != 6 && d.getDay() != 0) return val;
        } else {
          return val;
        }
      }
    },

    add() {
      if (this.$refs.pto_form.validate() == false) return;

      if (this.validateRequests() == false) {
        return;
      }

      this.inputs.push({
        start_menu: "",
        end_menu: "",
        start: "",
        end: "",
        type: "",
        full_partial: "",
        prenatal_start: "12:00 am",
        prenatal_end: "12:00 am"
      });
    }, 

    remove(index) {
      this.inputs.splice(index, 1);
    },

    submitPto() {
      // check required fields:
      if (this.$refs.pto_form.validate() == false) return;

      if (this.validateRequests() == false) {
        return;
      }

      /*
      //window.console.log(this.inputs);
      let debug = false;
      if (debug) {
        this.dialog_title = "Debug title";
        this.dialog_text = "Debug text";
        this.dialog_type = "debug";
        this.dialog = true;
      }
      */
     
        axios
          .post("./remote-apis/ptoSubmit.php", {
            formData: JSON.stringify(this.inputs),
            work_weekends: JSON.stringify(this.work_weekends),            
            action: JSON.stringify("add"),
          })
          .then((res) => { 
            if (res.data.response == "OK") {
              this.dialog_title = "Thank you!";
              this.dialog_text =
                "Your request has been submitted.";
              this.dialog_type = "success";
              this.dialog = true;
            } else if (res.data.response == "FAILURE") {
              this.dialog_title = "Alert!";
              if (res.data.message)
                this.dialog_text = res.data.message;
              else
              this.dialog_text =
                "Cannot process your request. Please try again later.";
              this.dialog_type = "failure";
              this.dialog = true;
            } else if (res.data.response == "FAILED") {
              this.dialog_title = "Alert!";
              if (res.data.message)
                this.dialog_text = res.data.message;
              else
              this.dialog_text =
                "Cannot process your request. Please try again.";
              this.dialog_type = "warning";
              this.dialog = true;
            } else if (res.data.response == "UNCONFIRMED") {
              this.dialog_title = "Alert!";
              this.dialog_text =
                "You must confirm your PTO before making new requests.";
              this.dialog_type = "balance";
              this.dialog = true;
            } else if (res.data.response == "DEBUG") {
              this.dialog_title = "Debug title";
              if (res.data.message)
                this.dialog_text = res.data.message;
              else
                this.dialog_text = "Debug text";
              this.dialog_type = "debug";
              this.dialog = true;
            } 
          })
          .catch((error) => {
            window.console.log(error);
            this.dialog_title = "Alert!";
              this.dialog_text =
                "Cannot process your request.";
              this.dialog_type = "alert";
              this.dialog = true;
          });
          return true;
      
    },

    /////////////////
    validateRequests() {
      var start = null;
      var end = null;
      var actualDates = [];
      var actualDays = [];
      var actualPrenatalStart = [] ;
      var actualPrenatalEnd = [] ;
      //var totalDays = { holiday: 0, personal: 0, sick: 0, vacation: 0, jury_duty: 0, bereavement: 0, c_vaccine: 0 };
      var totalDays = pto_func.getPtoCats("object_zero");
      var input_date = null;
      var day_of_week = null;
      var increment = 0.5;
      var type_name = "";
      var remaining = "";
      var formatted_input_date = "";
      var input_date_taken = false;
      var tmp_index = -1;
      var req_yr = null;
      var prenatal_start_time = null;
      var prenatal_end_time = null;
      var pto_unit = "day" ;

      //var debug = true;

      // for each request:
      for (var index = 0; index < this.inputs.length; index++) {
        start = new Date(this.inputs[index]["start"]+'T09:00:00.000Z');
        end = new Date(this.inputs[index]["end"]+'T09:00:00.000Z');

        if (end.getTime() < start.getTime()) {
          this.dialog_text = "End Date cannot be earlier than Start Date.";
          this.dialog_type = "error";
          this.dialog = true;
          return false;
        }       

        //increment = 0.5;
        //if (this.inputs[index]["full_partial"].toLowerCase() == "full") increment = 1;
        increment = pto_func.full_partial_to_num(this.inputs[index]["full_partial"]);

        if (this.inputs[index]["type"].toLowerCase() == "covid" && increment > 0.5) {
          this.dialog_text = "Please select AM or PM for COVID Vaccine/Booster.";
          this.dialog_type = "error";
          this.dialog = true;
          return false;
        } 

        if (this.inputs[index]["type"].toLowerCase() == "covid_sick" && increment < 1) {
          this.dialog_text = "Please select Full Day for COVID Sick Days.";
          this.dialog_type = "error";
          this.dialog = true;
          return false;
        } 

        if (this.inputs[index]["type"].toLowerCase() == "prenatal") {

          if (end.getTime() != start.getTime()) {
            this.dialog_text = "Prenatal Care Start Date and End Date must be the same.";
            this.dialog_type = "error";
            this.dialog = true;
            return false;
          }       

          prenatal_start_time = moment(this.inputs[index]["prenatal_start"], ['h:m a', 'H:m']) ;
          prenatal_end_time = moment(this.inputs[index]["prenatal_end"], ['h:m a', 'H:m']) ;

          if (prenatal_end_time.isBefore(prenatal_start_time) || prenatal_end_time.isSame(prenatal_start_time)) {
            this.dialog_text = "Prenatal Care Start Time must be earlier than the End Time.";
            this.dialog_type = "error";
            this.dialog = true;
            return false;
          }       

          // prenatal care minimum increments of one hour
          if ((prenatal_end_time.diff(prenatal_start_time, 'minutes') % 60) > 0) {
            this.dialog_text = "Prenatal Care must be scheduled in minimum increments of one hour.";
            this.dialog_type = "error";
            this.dialog = true;
            return false;
          }
  
          increment = prenatal_end_time.diff(prenatal_start_time, 'hours', true);

        } 

        // from start to end, validate each requested day:
        for (var d = start; d <= end; d.setDate(d.getDate() + 1)) {
          input_date = new Date(d); // d is a date object
          day_of_week = input_date.getDay();
          input_date_taken = false;
          tmp_index = -1; 

          req_yr = pto_func.get_fiscal_year("date_long", input_date);		

          if (
            this.au_holidays.includes(input_date.toISOString().slice(0, 10)) ||
            (this.work_weekends == false &&
              (day_of_week == 0 || day_of_week == 6))
          ) {
            // selection includes holiday or weekend, do not add to actualDates array, don't do anything
          } else {
            type_name = this.inputs[index]["type"];
            var display_type_name = type_name.replace("_", " ") ;

            if (type_name == "prenatal") {
              pto_unit = "hour" ;
              display_type_name = "Prenatal Care" ;
            } else {
              pto_unit = "day" ;
            }

            // check if exceed limits
            // assuming both taken and scheduled are not included in remaining
            remaining = this.pto_data[req_yr][type_name]['remain_total'];
            if (!remaining)
              remaining = 0;

            totalDays[req_yr][type_name] += increment;

            if (totalDays[req_yr][type_name] > remaining && type_name.toLowerCase() != "covid_sick" && type_name.toLowerCase() != "bereavement") {
              this.dialog_type = "error";
              if (remaining <= 0) {
                this.dialog_text = "You have no  " + display_type_name + " " + pto_unit + " remaining. ";
              } else {
                let args = {site_status: this.site_status, req_yr: req_yr, cur_fiscal_year: this.cur_fiscal_year, next_fiscal_year: this.next_fiscal_year, prev_fiscal_year: this.prev_fiscal_year};
                var fy_str = pto_func.get_fy_str("alert", args);
                this.dialog_text = `${
                  `Do not schedule more than  `
                  } ${remaining} ` + ` ` + display_type_name + ` ` + pto_unit +`(s) ` + fy_str + `.`;
              }
              this.dialog = true;
              return false;
            }

            // check if this day is in taken or scheduled array. format: "2024-11-14"
            formatted_input_date = pto_func.formatDate(input_date);

            if (type_name == "prenatal") {
              if (pto_func.is_input_date_taken(formatted_input_date, this.inputs[index]["prenatal_start"] + "_" + this.inputs[index]["prenatal_end"], this.pto, req_yr))
              input_date_taken = true;
            } else {
              if (pto_func.is_input_date_taken(formatted_input_date, this.inputs[index]["full_partial"], this.pto, req_yr))
                input_date_taken = true;
            }
/*
      if (debug) { 
      //continue;
      window.console.log(totalDays);
      window.console.log(this.pto_data);
      window.console.log(input_date_taken);
      this.dialog_title = "Test!";
      this.dialog_text = "Testing 2s....";
      this.dialog_type = "test";
      this.dialog = true; 
        return false; 
      }  
*/

            // reset
            tmp_index = -1;

            // check if the same date was selected previously (when add more was used)
            tmp_index = actualDates.map(Number).indexOf(+input_date); // same input date from previous

            if (tmp_index >= 0) {

              if (type_name == "prenatal") {

                // get indexes of requests that has the same input_date:
                let a_indx = actualDates
                  .map((date, index) => ({ date, index }))
                  .filter(item => item.date.getTime() === input_date.getTime())
                  .map(item => item.index);
                let param1 = "" ;
                let param2 = "";   
                let indx = 0 ;

                for (var y = 0; y < a_indx.length; y++) {
                  param1 = "" ;
                  param2 = "" ;
                  indx = a_indx[y] ;

                  if (actualDays[indx]['full_partial']) {   // value: full, am or pm
                      param1 = actualDays[indx]['full_partial'] ;
                  } else {
                      param1 = actualPrenatalStart[indx] + "_" + actualPrenatalEnd[indx] ;
                  }

                  param2 = this.inputs[index]["prenatal_start"] + "_" +this.inputs[index]["prenatal_end"] ;

                  if (pto_func.dayHasConflict(param1, param2 )) {
                      input_date_taken = true;
                      break;
                  }

                }

              } else if (
                pto_func.dayHasConflict(
                  actualDays[tmp_index],
                  this.inputs[index]["full_partial"]
                )
              )
                input_date_taken = true;
            }

            // selected date was taken
            if (input_date_taken == true) {

              let fp_str = "" ;
              if (type_name == "prenatal")
                fp_str = "" ;
              else if (this.inputs[index]["full_partial"].toLowerCase() == "full")
                fp_str = "Full Day" ;
              else
                fp_str = this.inputs[index]["full_partial"] ;

              this.dialog_type = "error";
              this.dialog_text =
                "Selected date " +
                formatted_input_date +
                " " + fp_str + 
                " was taken or scheduled already." ;
              this.dialog = true;
              return false;
            }
            // actualDates is for checking conflicts only, not for submitting to saas
            actualDates.push(input_date);
            actualDays.push(this.inputs[index]["full_partial"]);
            if (type_name == "prenatal") {
              actualPrenatalStart.push(this.inputs[index]['prenatal_start']) ;
              actualPrenatalEnd.push(this.inputs[index]['prenatal_end']) ;
            } else {
              actualPrenatalStart.push("") ;
              actualPrenatalEnd.push("") ;
            }
          }
        }
      }
/*
this.dialog_title = "Test!";
this.dialog_text = "Testing 6 .... " + totalDays[req_yr][type_name] + ", " + remaining ;
this.dialog_type = "test";
this.dialog = true;
if (debug == true)
  return false;
*/
      return true;
    },

    confirmPtoAlert() {
      this.dialog_text = "You must confirm your PTO before making new requests.";
      this.dialog_type = "balance";
      this.dialog = true;
      return false; 
    },

  }, // methods

  created() {

    if (this.ptoInfo['showReqBalTab'] == false ) {   
      // faculty approver cannot make pto request
      this.$router.push({
          path: "/pto/manager",
        });
        return false;
    }

    if (this.ptoInfo['p_cfm_prev']) {   
        this.confirmPtoAlert();
        return false;
    } /* else {
      // redundent check, sometimes ptoInfo['p_cfm_prev'] = false but it should be true
      axios.get("./remote-apis/pto_api.php?cmd=pto_pc").then((response) => {
        this.pc = response.data;
        if (this.pc.response == 0) {
           this.p_cfm_prev = pto_func.get_cfm_status("prev", this.pc.pending_confirmed);
            if (this.p_cfm_prev == true) {
             this.confirmPtoAlert();
             return false;
            }
        }
      }); 
    } */


      axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.cur_fiscal_year).then((response) => {
        this.saas_data = response.data;
        this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.cur_fiscal_year);
        //window.console.log(this.pto);
        this.pto_data['firstname'] = this.pto_data[this.cur_fiscal_year]['firstname'];
        this.pto_data['lastname'] = this.pto_data[this.cur_fiscal_year]['lastname'];
        this.ptoInfo['gender'] = this.pto_data[this.cur_fiscal_year]['gender'];
        this.pto_types = pto_func.getPtoCats("object", this.ptoInfo['gender']);
        //window.console.log(this.pto_data);
      })
      .catch(error => {
          window.console.error(error);
      });

     
      if (this.site_status == "cur_and_next_year") {
        this.next_fiscal_year = pto_func.get_fiscal_year("next_long");
        axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.next_fiscal_year).then((response) => {
          this.saas_data = response.data;
          this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.next_fiscal_year);
          //window.console.log(this.pto);
        })
        .catch(error => {
          window.onsole.error(error);
        });
      } else if (this.site_status == "prev_and_cur_year") {
        axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.prev_fiscal_year).then((response) => {
          this.saas_data = response.data;
          this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.prev_fiscal_year);
          //window.console.log(this.pto);
        })
        .catch(error => {
          window.console.error(error);
        });
      } else if (this.site_status == "transition_rough") {
        this.dialog2_text = "During our PTO reconciliation process you will not be able to request future leave until our anticipated completion date of September 16, 2022. At this moment you may only approve, add or remove leave taken during August 2022. <br /><br />We apologize for the inconvenience but please note this does not mean you can't take leave during this time. We ask that you communicate with your manager or whomever traditionally approves your leave to seek approval. <br /><br />Thank you for your patience.";
        this.dialog2_type = "transition";
        this.dialog2 = true;
      }

 },

  mounted() {
    // au holidays
     axios.get("./remote-apis/pto_api.php?cmd=pto_holiday").then((response) => {
        this.saas_holidays = response.data;
        this.au_holidays = pto_func.formatAuHolidays(this.saas_holidays);
        this.date_picker_max = pto_func.get_date_picker_max();
      })
      .catch(error => {
          window.console.error(error);
        });
    this.pto_cat_names = pto_func.getPtoCats("names");
    this.pto_cat_plurals = pto_func.getPtoCats("plurals");
    this.pto_cat_codes = pto_func.getPtoCats("codes");
    } 

   
};

</script>

<style scoped>
.custom1cols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.custom3cols {
  width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  padding-left: 5px;
  padding-bottom: 0px;
}

.custom4cols {
  width: 33%;
  max-width: 33%;
  flex-basis: 33%;
  padding-bottom: 0px;
}

.custom9cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.hidden {
  display: none;
}

.v-input {
  max-width: 80%;
}

.messages /deep/ .v-messages,
.messages /deep/ .v-messages__message {
  font-size: 16px !important;
}

.black--text /deep/ label {
  color: #000000 !important;
  font-weight: 400 !important;
}
.dt-picker /deep/ .v-btn {
  border-radius: 28px !important;
}

.dt-picker_ /deep/ .v-btn--outlined {
  border: 4px solid #ffb500 !important;
  color: #4f2c1d !important;
}

.dt-picker_ /deep/ .v-date-picker-table .v-btn.v-btn--active {
  color: #4f2c1d !important;
}

.prompt {
  font-weight: bold;
  font-size: 1em;
  color: #000 !important;
}

.first-row__ {
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 12px 12px 12px 0;
}

.field-row__ {
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 12px 12px 12px 0;
}

.inst {
  margin-top: 1px;
  font-style: italic;
  font-size: 13px;
  width: 80%;
  padding-bottom: 0;
  margin-bottom: 0;
}

.inst a {
  text-decoration-color: #ffb500 !important;
  text-decoration-thickness: 2px !important;
  text-decoration: underline;
}

.submit-row {
  padding: 12px 0 24px 0;
  margin-bottom: 50px;
}

.row {
  padding-top: 0;
  padding-bottom: 0;
}

.alert_spacing {
  margin-right: 5px !important;
}



</style>

<style>

.vue__time-picker-dropdown ul li:not([disabled]).active,
.vue__time-picker-dropdown ul li:not([disabled]).active:focus,
.vue__time-picker-dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover{
  background:#ffb500 !important;
  color:#000 ;
}

</style>

